/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Organization_InternalInputs */

const en_error_organization_internal = /** @type {(inputs: Error_Organization_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomorrow itself cannot be archived or merged.`)
};

/**
* | output |
* | --- |
* | "Tomorrow itself cannot be archived or merged." |
*
* @param {Error_Organization_InternalInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_organization_internal = /** @type {((inputs?: Error_Organization_InternalInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Organization_InternalInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_organization_internal(inputs)
});